import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './fonts.css'; // self-hosted @font-face — must load before tokens/index
import './tokens.css';
import './index.css';
import App from './App.tsx';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
